import React from 'react';
import PotteryActivity2024  from 'views/PotteryActivity2024';

const CoworkingPage = () => {
  return <PotteryActivity2024 />;
};

export default CoworkingPage;
